<div *ngIf="!loading">
    <div *ngFor="let group of groups" class="facet-group">
      <app-facetgroup [group]="group"
                      [applied]="appliedInGroup(group)"
                      [open]="isOpen(group)"
                      (facetToggled)="toggled($event)"
                      (groupToggled)="facetgroupToggled($event)">
      </app-facetgroup>
    </div>
</div>
